module.exports = __webpack_public_path__ + "img/ptzc01.1ea99c3e.png";